import { gql } from '@apollo/client';
import {
  PLAYER_INFO_FRAGMENT,
  PLAYER_STATS_FRAGMENT,
  SCHEDULE_FRAGMENT,
} from '../../fragments';

export const GET_ARCHIVE_SINGLE_SEASON_INFO = gql`
  ${PLAYER_STATS_FRAGMENT}
  ${PLAYER_INFO_FRAGMENT}
  ${SCHEDULE_FRAGMENT}
  query GetArchiveSingleSeasonInfo($seasonId: Int!) {
    schedule(
      where: { seasonId: { _eq: $seasonId } }
      order_by: { date: asc, time: asc }
    ) {
      ...ScheduleFragment
      goalieAttendance: attendance(
        where: {
          _or: [
            { player: { positionSecondary: { _eq: GOALIE } } }
            { player: { position: { _eq: GOALIE } } }
          ]
        }
      ) {
        teamId
        player {
          id
          firstName
          lastName
          jersey
          jerseySecondary
          rosters {
            team {
              id
              name
            }
          }
        }
      }
    }
    seasons(where: { id: { _eq: $seasonId } }) {
      id
      league
      notes
      season
      year
      teams {
        champion
        color
        colorSecondary
        division
        id
        name
        captainPlayer {
          firstName
          id
          lastName
        }
        skaterStats {
          ...PlayerStats
          playerByPlayer {
            ...PlayerInfo
          }
        }
      }
    }
  }
`;
